let scriptsLoaded = false;

function loadScripts(e) {
  if (scriptsLoaded || (e && !e.isTrusted)) return;
  scriptsLoaded = true;
    setTimeout(function () {
        // Render JS files
        loadScript("//www.theindusvalley.in/cdn/shop/t/194/assets/theme-vendors.js?v=82816576819930053461787229407");    
        // loadScript("//www.theindusvalley.in/cdn/shop/t/194/assets/global.js?v=29746711756982380231787229407");  


        // Render CSS files
        loadCSS("//www.theindusvalley.in/cdn/shop/t/194/assets/component-predictive-search.css?v=118923337488134913561787229407");
        loadCSS("//www.theindusvalley.in/cdn/shop/t/194/assets/quantity-popover.css?v=78745769908715669131787229407");
        // loadCSS("//www.theindusvalley.in/cdn/shop/t/194/assets/component-card.css?v=160707831431874680301787229407");
        loadCSS("//www.theindusvalley.in/cdn/shop/t/194/assets/component-list-social.css?v=35792976012981934991787229407");
        loadCSS("//www.theindusvalley.in/cdn/shop/t/194/assets/app.css?v=109475306447804688291787229407");
        loadCSS("//www.theindusvalley.in/cdn/shop/t/194/assets/component-price.css?v=17339892820084782851787229407");   //--------
        loadCSS("//www.theindusvalley.in/cdn/shop/t/194/assets/component-search.css?v=51982010362037728451787229407");
        loadCSS("//www.theindusvalley.in/cdn/shop/t/194/assets/featured-collection.css?v=36723672863755839161787229407");
        loadCSS("//www.theindusvalley.in/cdn/shop/t/194/assets/component-rating.css?v=179577762467860590411787229407");
        loadCSS("//www.theindusvalley.in/cdn/shop/t/194/assets/quick-order-list.css?v=38387008350345892421787229407");
        loadCSS("//www.theindusvalley.in/cdn/shop/t/194/assets/product-card.css?v=61410051075824158211787229407");
        loadCSS("//www.theindusvalley.in/cdn/shop/t/194/assets/award.css?v=102426195241050143001787229407");
        loadCSS("//www.theindusvalley.in/cdn/shop/t/194/assets/component-cart-notification.css?v=54116361853792938221787229407");  //--------
        loadCSS("//www.theindusvalley.in/cdn/shop/t/194/assets/component-article-card.css?v=47105078945762260691787229407");
        loadCSS("//www.theindusvalley.in/cdn/shop/t/194/assets/component-accordion.css?v=180964204318874863811787229407");
        loadCSS("//www.theindusvalley.in/cdn/shop/t/194/assets/collapsible-content.css?v=93940462134355214101787229407");
        loadCSS("//www.theindusvalley.in/cdn/shop/t/194/assets/pdp-table-section.css?v=67313869335911071091787229407");
        loadCSS("//www.theindusvalley.in/cdn/shop/t/194/assets/component-newsletter.css?v=99314662370404002431787229407");
        loadCSS("//www.theindusvalley.in/cdn/shop/t/194/assets/newsletter-section.css?v=62410470717655853621787229407");
        loadCSS("//www.theindusvalley.in/cdn/shop/t/194/assets/component-totals.css?v=15906652033866631521787229407");
        loadCSS("//www.theindusvalley.in/cdn/shop/t/194/assets/component-discounts.css?v=152760482443307489271787229407");
    }, 10);


  document.removeEventListener('click', loadScripts);
  document.removeEventListener('mouseover', loadScripts);
  document.removeEventListener('scroll', loadScripts);
}

if (window.scrollY >= 400) {
  loadScripts();
} else {
  document.addEventListener('mouseover', loadScripts);
  document.addEventListener('click', loadScripts);
  document.addEventListener('scroll', loadScripts);
}

function loadScript(src) {
  var script = document.createElement('script');
  script.src = src;
  script.async = true;
  document.head.appendChild(script);
}

function loadScriptWithCallBack(src, callback) {
  var script = document.createElement('script');
  script.src = src;
  script.onload = callback || function () {};
  document.head.appendChild(script);
}

function loadCSS(href) {
  var link = document.createElement('link');
  link.href = href;
  link.rel = 'stylesheet';
  link.type = 'text/css';
  document.head.appendChild(link);
}